import './stepper.scss';
import FontBody2 from "../fonts/font-body2/font-body2";
import FontBody4 from "../fonts/font-body4/font-body4";
import {FONT_COLOR, FONT_VARIANT} from "../fonts/font-props";
import IconMinus from "../icons/icon-minus/icon-minus";
import IconPlusNotRounded from "../icons/icon-plus-not-rounded/icon-plus-not-rounded";

export enum STEPPER_LABEL_POSITION {
	LEFT = 'left',
	TOP = 'top'
}
interface IStepper {
	title?: React.ReactNode;
	labelPosition?: STEPPER_LABEL_POSITION;
	label?: React.ReactNode;
    singleItemLabel?: React.ReactNode;
	value: number;
	onChange: (value: number) => void;
	min?: number;
	max?: number;
	disabled?: boolean;
	viewOnly?: boolean;
	stepSize?: number;
}
const Stepper: React.FC<IStepper> = ({title, value, onChange, max, min, disabled = false, viewOnly = false, label, singleItemLabel, stepSize = 1, labelPosition}) => {
	
	const minusDisabled = min !== undefined && (value - stepSize!) < min;
	const plusDisabled = max !== undefined && (value + stepSize!) > max;
	const handleMinusClick = () => {
		if(viewOnly || disabled){
			return;
		}
		if(minusDisabled){
			return ;
		}
		onChange(value - stepSize!);
	}
	const handlePlusClick = () => {
		if(viewOnly || disabled){
			return;
		}
        if(plusDisabled) {
			return ;
        }
		onChange(value + stepSize!);
    }
	const handleKeyDown = (e:React.KeyboardEvent) => {
		e.preventDefault();
		//down or left keyboard click
		if(e.key === 'ArrowDown' || e.key === 'ArrowLeft') {
			handleMinusClick();
		}
		//up or right keyboard click
		if(e.key === 'ArrowUp' || e.key === 'ArrowRight'){
            handlePlusClick();
        }
	}
	let viewOnlyOrDisabledClass = '';
	if (viewOnly) {
		viewOnlyOrDisabledClass = 'view-only';
	}
	if (disabled) {
		viewOnlyOrDisabledClass = 'disabled';
	}
	
	return (
		<div className='stepper'>
			<div className={'stepper-flex-wrapper' + (labelPosition === STEPPER_LABEL_POSITION.LEFT ? ' stepper-make-row':'')}>
				{title && <div className='stepper-title'><FontBody2 variant={FONT_VARIANT.BOLD}>{title}</FontBody2></div>}
				<div className='stepper-flex-row'>
					<div className={'stepper-wrapper ' + viewOnlyOrDisabledClass} onKeyDown={handleKeyDown} tabIndex={0}>
						<div className={'btn-minus ' + (minusDisabled ? 'disabled' : '')}
						     onClick={handleMinusClick}><IconMinus/></div>
						<div className='stepper-value'>{value}</div>
						<div className={'btn-plus ' + (plusDisabled ? 'disabled' : '')}
						     onClick={handlePlusClick}><IconPlusNotRounded/></div>
					</div>
					{(label || singleItemLabel)  && (
						<div className='stepper-label'>
							<FontBody4 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.NEUTRAL3}>{
								value > 1
								? label ?? singleItemLabel
								: singleItemLabel ?? label
							}</FontBody4>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default Stepper;